import { apiClient } from "@/lib/apiClient";
import type { DocumentType, DocumentTypesResponse } from "@/types/domain";

export async function getDocumentTypes(): Promise<DocumentType[]> {
  const res = await apiClient.get<DocumentTypesResponse>("/api/document-types");
  return res.documentTypes;
}
